import DecimalType from "decimal.js";

export type TLitterPricingDetails = {
  unitPrice: DecimalType;
  totalPrice: DecimalType;
  bulkDiscountPercentage: DecimalType;
};

export enum LitterProduct {
  SCOOP_HEALTH = "SCOOP_HEALTH",
  SCOOP_PLANET = "SCOOP_PLANET",
}

export type TLitterPricingByQuantity = Record<number, TLitterPricingDetails>;

export interface IUpdateScoopFrequencyAndQuantityRequest {
  subscriptionId: number;
  frequencyInWeeks?: number;
  quantity?: number;
}
export interface IUpdateScoopFrequencyAndQuantityResponse {
  subscriptionId: number;
  frequencyInWeeks: number;
  quantity: number;
}

export const MAX_LITTER_QUANTITY = 4 as const;

export const MAX_LITTER_FREQUENCY_IN_WEEKS = 16 as const;
